export default __webpack_public_path__ + "static/media/secure.4c44d618.svg";